import styled from 'styled-components';
import Row from '@sdk/components/ui/spacing/Row';

type Props = {
  useWhiteBg: boolean;
  useBtn150: boolean;
};
export const ButtonContainer = styled(Row)<Props>`
  background-color: ${({ theme, useWhiteBg }) => (useWhiteBg ? theme.colors.white : 'transparent')};
  width: ${({ useBtn150 }) => (useBtn150 ? 150 : 140)}px;
  height: ${({ useBtn150 }) => (useBtn150 ? 36 : 34)}px;
  border-radius: 4px;
`;
